<template>
  <section class="Hero">
    <video autoplay muted playsinline loop id="myVideo">
      <source src="../assets/video/ASU_Header_1080p_24fps.mp4" type="video/mp4">Your browser does not support HTML5 video.
    </video>
    <div class="content"></div>
  </section>
</template>
<style>
</style>

<script>
export default {
  name: "HeroComponent",
  created() {
    $(document).ready(function() {
      setTimeout(() => {
        $(".background-video").addClass("fade-in");
      }, 4500);
    });
  }
};
</script>

<style scoped>
</style>

